import { IconShoppingCart } from "@tabler/icons-react";

import { formatMoney } from "@greeter/formatters";
import { classNames } from "@greeter/util";

import css from "./AddToCartButton.module.scss";
import { Card } from "@greeter/matter-v2";

export function AddToCartButton(props: {
  total?: number;
  onClick?: () => void;
  disabled?: boolean;
}) {
  return (
    <Card
      layout
      layoutId="add-to-cart"
      variant="green"
      act="button"
      onClick={props.onClick}
      {...classNames(css.AddToCartCutton, props.disabled && css.Disabled)}
    >
      <Card.Content preset="flex-aligned-center">
        <IconShoppingCart
          className={css.CartIcon}
          style={{ strokeWidth: 2 }}
          vectorEffect="non-scaling-stroke"
        />
        <span style={{ fontWeight: "bold" }}>
          Tilføj til bord(e)
          {props.total && ` (${formatMoney(props.total)} kr.)`}
        </span>
      </Card.Content>
    </Card>
  );
}
